import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { getItemWebStorage } from "../../../../features/webStorageSaver";
import { getAllObjectsLayer, getBasicObjectTypeLayer } from "../../../../widgets/map/mapFeatures/layers";
import { showMapTooltip } from "../../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip";
import { setMapTooltipIsVisible } from "../../../../stateManagement/reducers";
import { getObjectsOnWMSLayer } from "../../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import { LastYearsMapFilter, buildYearsEnv, getCheckedLastYears, getLastYearsCqlFilter } from "../../../lastYearsMapFilter";
import { MapTooltip } from "../../../../widgets/map/mapAddons/mapTooltip";
import MapWidget from "../../../../widgets/map/mapWidget/MapWidget";
import TableUnderMapSingleType  from "../../../tables/tableUnderMap/TableUnderMapSingleType";
import { falseTableFilterExpression } from "../../../../widgets/table/tableFeatures/tableFunctions";

export default function MapRoadDiagnosticsSegmentsPassport() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mapName = "RoadDiagnosticsSegmentsPassport"
    const numberOfYears = 6
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [isSmallWindow, setIsSmallWindow] = useState(true);
    const [tableUnderMapFilterString, setTableUnderMapFilterString] = useState<any>(null)
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const yearFilter = useAppSelector(state => state.mapFilters?.lastYearsMapFilters)?.[mapName] ?? {}
    const { wmsServer, wmsVersion, workspace, menuAdditionalItems } = getItemWebStorage('currentConfig')
    const menuItem = menuAdditionalItems.find((menuItem: any) => menuItem?.item?.type === `map.${mapName}`)?.item
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)

    const roadsLayer = getAllObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, mapStaticFilter, title } = menuItem
        title && setMapTitle(`Карта «${title}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        let layerFilterArray = []
        if (mapStaticFilter) {
            layerFilterArray.push(mapStaticFilter)
        }
        layerFilterArray.push(getLastYearsCqlFilter(yearFilter))
        let layerFilter = layerFilterArray.join(' and ')
        const objectTypeLayer = getBasicObjectTypeLayer(
            mapLayer,
            wmsServer,
            wmsVersion,
            workspace,
            layerFilter,
            undefined,
            buildYearsEnv(numberOfYears)
        )
        setAdditionalLayers([objectTypeLayer])
    }, [yearFilter]);

    useEffect(() => {
        const { tableUnderMapStaticFilter } = menuItem
        let tableUnderMapFilterArray = []
        if (tableUnderMapStaticFilter) {
            tableUnderMapFilterArray.push(tableUnderMapStaticFilter)
        }
        const checkedYears = getCheckedLastYears(yearFilter)
        let tableUnderMapYearsFilterArray: any = []
        checkedYears.map((checkedYear: any) => {
            tableUnderMapYearsFilterArray.push(`EventYear eq ${checkedYear}`)
        })
        if (tableUnderMapYearsFilterArray.length > 0) {
            tableUnderMapFilterArray.push(`(${tableUnderMapYearsFilterArray.join(' or ')})`)
        } else {
            tableUnderMapFilterArray.push(falseTableFilterExpression)
        }
        let tableUnderMapFilterString = tableUnderMapFilterArray.join(' and ')
        setTableUnderMapFilterString(tableUnderMapFilterString)
    }, [yearFilter])

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallWindow(contentHeaderWidth < 440);
    }, [sideBarState, navigate])

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, mapName, additionalLayers[0], map)
        map?.on("pointermove", pointerMoveFunc)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnWMSLayer(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        },
        {
            name: "objectsFind",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={mapName} type="map" />
            <div className="map-widget-with-toast">
                {!isSmallWindow && <LastYearsMapFilter filterType="header" numberOfYears={numberOfYears} objectType={mapName} />}
                <MapTooltip type={mapName} />
                <MapWidget
                    additionalLayers={additionalLayers}
                    mapEventHandlers={mapEventHandlers}
                    permanentLayers={permanentLayers}
                    mapSizeClass={tableUnderMapIsShown ? 'half-size-map-widget' : null}
                />
                {tableUnderMapIsShown &&
                    <TableUnderMapSingleType 
                        objectType="RoadDiagnosticsSegments"
                        canBeFiltered={false}
                        filtersExpression={tableUnderMapFilterString}
                    />}
            </div>
        </>
    )
}
